<template>
  <div class="what">
    <Header current="build" active="what" @scroll="handleScroll"></Header>
    <div class="start con">
      <h3>{{ $t('lang.what.title') }}</h3>
      <p class="f12">{{ $t('lang.what.text1') }}</p>
      <p class="f12 mbtm5">{{ $t('lang.what.text2') }}</p>
      <button class="btn" @click="gotoLink(link.whitepaper)">{{ $t('lang.what.btn') }}</button>
    </div>
    <div class="features">
      <div class="con">
        <h3>{{ $t('lang.what.features.title') }}</h3>
        <div class="wrapper">
          <div>
            <span class="sub-title">{{ $t('lang.what.features.subtitle1') }}</span>
            <p class="text f12">{{ $t('lang.what.features.subtext1') }}</p>
            <span class="sub-title">{{ $t('lang.what.features.subtitle2') }}</span>
            <p class="text f12">{{ $t('lang.what.features.subtext2') }}</p>
            <br />
            <p class="text f12">{{ $t('lang.what.features.subtext3') }}</p>
          </div>
          <div class="tri">
            <img :src="triImg" />
            <!-- <div class="nodes-list">
                            <div class="nodes">
                                <p class="f12">{{ $t('lang.what.features.super') }}</p>
                                <p class="f12">{{ $t('lang.what.features.nodes') }}</p>
                            </div>
                            <div class="nodes">
                                <p class="f12">{{ $t('lang.what.features.regular') }}</p>
                                <p class="f12">{{ $t('lang.what.features.nodes') }}</p>
                            </div>
                            <div class="nodes">
                                <p class="f12">{{ $t('lang.what.features.child') }}</p>
                                <p class="f12">{{ $t('lang.what.features.nodes') }}</p>
                            </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="token">
      <div class="con">
        <h3>{{ $t('lang.what.token.title') }}</h3>
        <p class="f12">{{ $t('lang.what.token.text1') }}</p>
        <p class="f12">
          {{ $t('lang.what.token.text2') }}
          <span
            @click="goto('exchanges')"
          >{{ $t('lang.what.token.span2') }}</span>
        </p>
        <p class="f12">
          {{ $t('lang.what.token.text3') }}
          <span
            @click="gotoLink(what.dna_wallet)"
          >{{ $t('lang.what.token.span3') }}</span>
        </p>
        <p class="f12">
          {{ $t('lang.what.token.text4') }}
          <span
            @click="gotoLink(what.dna_explorer)"
          >{{ $t('lang.what.token.span4') }}</span>
        </p>
      </div>
    </div>
    <div class="version" id="helix">
      <div class="con">
        <h3>{{ $t('lang.what.version') }}</h3>
        <p class="f12">{{ $t('lang.what.versionText') }}</p>
        <div class="list">
          <h5>{{ $t('lang.what.tps') }}</h5>
          <div class="item">
            <div>
              <img :src="tpsImg" class="time-img" />
            </div>
            <!-- <ul>
                            <li class="dna">
                                <span>DNA</span>
                                <div class="line first">
                                    <span>10,000+TPS</span>
                                    <div style="width: 100%" class="proress"></div>
                                    <span class="higher f12">{{ $t('lang.what.higher') }}</span>
                                </div>
                            </li>
                            <li class="btc">
                                <span>BTC</span>
                                <div class="line">
                                    <div style="width: 7%" class="proress"></div>
                                    <span>7 TPS</span>
                                </div>
                            </li>
                            <li class="eth">
                                <span>ETH</span>
                                <div class="line">
                                    <div style="width: 15%" class="proress"></div>
                                    <span>15-25 TPS</span>
                                </div>
                            </li>
                            <li class="ada">
                                <span>ADA</span>
                                <div class="line">
                                    <div style="width: 50%" class="proress"></div>
                                    <span>50-250 TPS</span>
                                </div>
                            </li>
            </ul>-->
          </div>
        </div>
        <div class="list">
          <h5>{{ $t('lang.what.time') }}</h5>
          <div class="item">
            <div>
              <img :src="timeImg" class="time-img" />
            </div>
          </div>
        </div>
        <div class="list">
          <h5>{{ $t('lang.what.digital') }}</h5>
          <div class="item">
            <div>
              <img :src="didImg" class="time-img" />
            </div>
            <!-- <div class="digital">
                            <div class="dna">
                                <span class="f12">Metaverse DNA</span>
                                <i class="right"></i>
                                <span class="simple hide">{{ $t('lang.what.simple') }}</span>
                            </div>
                            <div class="btc">
                                <span class="f12">Bitcoin</span>
                                <i class="error"></i>
                            </div>
                            <div class="eth">
                                <span class="f12">Ethereum</span>
                                <i class="error"></i>
                            </div>
                            <div class="ada">
                                <span class="f12">Cardano</span>
                                <i class="error"></i>
                            </div>
            </div>-->
          </div>
        </div>
        <div class="list">
          <h5>{{ $t('lang.what.price') }}</h5>
          <div class="item">
            <div>
              <img :src="priceImg" class="time-img" />
            </div>
            <p class="according">{{ $t('lang.what.according') }}</p>
            <div class="price-btn">
              <button class="btn" @click="gotoLink(link.whitepaper)">{{ $t('lang.what.read') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="map con">
      <h3>{{ $t('lang.what.map') }}</h3>
      <div class="item">
        <span v-for="(item, index) in [2016, 2017, 2018, 2019, 2020]" :key="index">{{ item }}</span>
      </div>
    </div>-->
  </div>
</template>

<script>
import Header from "@/components/Header";
import { home, what } from "../../common/link.js";
export default {
  name: "What",
  components: {
    Header,
  },
  data() {
    return {
      triImg: "",
      tpsImg: "",
      timeImg: "",
      didImg: "",
      priceImg: "",
      link: home,
      what: what,
      imgInv: 0,
    };
  },
  created() {
    localStorage.setItem("url", "what");
    this.triImg = require("../../assets/images/tri-en-US.png");
    this.tpsImg = require("../../assets/images/what-tps-en-US.png");

    this.timeImg = require("../../assets/images/what-blocktime-en-US.png");
    this.didImg = require("../../assets/images/what-did-en-US.png");
    this.priceImg = require("../../assets/images/what-price-en-US.png");

    clearInterval(this.imgInv);
    this.imgInv = setInterval(() => {
      let lang = this.$i18n.locale;
      //console.log(lang);
      if (lang == "zh-CN") {
        this.triImg = require("../../assets/images/tri-zh-CN.png");
        this.tpsImg = require("../../assets/images/what-tps-zh-CN.png");
        this.timeImg = require("../../assets/images/what-blocktime-zh-CN.png");
        this.didImg = require("../../assets/images/what-did-zh-CN.png");
        this.priceImg = require("../../assets/images/what-price-zh-CN.png");
      } else {
        this.triImg = require("../../assets/images/tri-en-US.png");
        this.tpsImg = require("../../assets/images/what-tps-en-US.png");
        this.timeImg = require("../../assets/images/what-blocktime-en-US.png");
        this.didImg = require("../../assets/images/what-did-en-US.png");
        this.priceImg = require("../../assets/images/what-price-en-US.png");
      }
    }, 1000);
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.id == "helix") {
      this.handleScroll(this.$route.params.id);
    }
  },
  methods: {
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(url, "_blank");
    },
    handleScroll(id) {
      if (id) {
        let offsetTop = document.querySelector("#" + id).offsetTop;
        window.scrollTo(0, offsetTop - 60);
      } else {
        window.scrollTo(0, 0);
      }
    },
    goto() {
      if (this.$route.name == "Connect") {
        this.$emit("scroll", "exchanges");
      } else {
        this.$router.push({ name: "Connect", params: { id: "exchanges" } });
      }
    },
  },
  destroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

.what {
  padding-top: 0.96rem;

  .start, .token, .version, .map {
    h3 {
      title();
      margin-bottom: 0.3rem;
    }

    p {
      text();
      margin-bottom: 0.3rem;

      &.mbtm4 {
        margin-bottom: 0.4rem;
      }

      &.mbtm45 {
        margin-bottom: 0.45rem;
      }

      &.mbtm5 {
        margin-bottom: 0.5rem;
      }
    }
  }

  .start {
    .btn {
      width: 3.9rem;
      height: 0.6rem;
    }
  }

  .features {
    background-color: $otherColor;

    .wrapper {
      center();
      justify-content: space-between;
    }

    h3 {
      title();
    }

    .sub-title {
      font-size: 0.3rem;
      line-height: 0.72rem;
      color: $title;

      &:after {
        content: '';
        display: block;
        width: 0.34rem;
        margin-bottom: 0.18rem;
        height: 1px;
        background-color: #000;
      }
    }

    .text {
      text();
    }

    .tri {
      position: relative;
      width: 5.68rem;
      height: 4.16rem;

      img {
        height: 100%;
      }

      .nodes-list {
        position: absolute;
        top: 0;
        width: 100%;
      }

      .nodes {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 1.25rem;
        color: $white;

        &:first-child {
          height: 1.8rem;
        }

        p {
          font-size: 0.18rem;
          text-align: center;
          margin-bottom: 0.06rem;

          &:last-child {
            font-size: 0.14rem;
          }
        }
      }
    }
  }

  .token {
    height: 4.69rem;
    background: url('../../assets/images/whatbg.png') left top no-repeat;
    background-size: 100% 100%;

    h3, p {
      color: $white;
    }

    span {
      color: #00efcc;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .version {
    background-color: $otherColor;

    .list {
    }

    h5 {
      font-size: 0.3rem;
      text-align: center;
      padding: 0.3rem 0;
    }

    .item {
      margin-bottom: 0.3rem;
      background-color: $white;
    }

    .time-img {
      width: auto;
      max-width: 100%;
    }

    ul {
      li {
        center();
        border-bottom: 1px solid #e7e7e7;
        margin: 0 0.3rem;
        height: 0.72rem;

        &:before {
          content: '';
          width: 0.37rem;
          height: 0.27rem;
        }

        >span {
          font-size: 0.24rem;
          line-height: 0.3rem;
          color: $dark;
          margin: 0 0.1rem;
        }

        .line {
          flex: 1;
          center();

          &.first {
            flex-direction: column;
            align-items: flex-end;
          }

          .proress {
            height: 0.11rem;
            background-color: $btnColor;
          }

          span {
            font-size: 0.18rem;
            color: $dark;
            margin-left: 0.2rem;
            line-height: 0.24rem;
          }

          .higher {
            font-size: 0.14rem;
            color: #858585;
            ellipsis();
          }
        }
      }
    }

    .dna:before {
      background: url('../../assets/images/dna.png') center center no-repeat;
      background-size: 100% auto;
    }

    .btc:before {
      background: url('../../assets/images/btc.png') center center no-repeat;
      background-size: auto 85%;
    }

    .eth:before {
      background: url('../../assets/images/eth.png') center center no-repeat;
      background-size: auto 85%;
    }

    .ada:before {
      background: url('../../assets/images/ada.png') center center no-repeat;
      background-size: auto 85%;
    }

    .according {
      font-size: 0.14rem;
      text-align: center;
    }

    .price-btn {
      padding-bottom: 0.4rem;
      text-align: center;
    }

    .btn {
      width: 3.71rem;
      height: 0.6rem;
    }

    .digital {
      div {
        center();
        padding: 0 0.3rem;
        height: 0.68rem;

        &:before {
          content: '';
          width: 0.37rem;
          height: 0.27rem;
        }

        &:nth-child(2n+1) {
          background-color: rgba(247, 147, 26, 0.08);
        }

        span {
          font-size: 0.18rem;
          line-height: 0.24rem;
          color: $dark;
          width: 25%;
          padding-left: 0.3rem;
        }

        i {
          width: 0.27rem;
          height: 0.27rem;
          border: 2px solid #bababa;

          &.right {
            background: url('../../assets/images/right.png') center center no-repeat;
            background-size: 100% auto;
          }

          &.error {
            background: url('../../assets/images/error.png') center center no-repeat;
            background-size: 75% auto;
          }
        }

        .simple {
          width: 70%;
          text-align: center;
          ellipsis();
        }
      }
    }
  }

  .map {
    .item {
      position: relative;
      center();
      padding: 0 0.2rem;

      &:before {
        content: '';
        position: absolute;
        top: 25%;
        z-index: -1;
        margin-left: 0.1rem;
        display: block;
        width: 96%;
        height: 1px;
        border-top: 1px dashed #bababa;
      }

      span {
        flex: 1;
        font-size: 0.18rem;
        line-height: 0.24rem;

        &:before {
          content: '';
          display: block;
          width: 0.28rem;
          height: 0.28rem;
          background-color: $btnColor;
          margin: 0 0 0.1rem 0.06rem;
        }
      }
    }
  }
}

@media screen and (max-width: 720px) {
  .what {
    padding-top: 40px;

    .start {
      .btn {
        width: 160px;
      }
    }

    .token {
      height: 11.5rem;
    }

    .version {
      ul {
        li {
          height: 45px;

          &:before {
            width: 24px;
            height: 18px;
          }

          .line {
            span {
              margin-bottom: 3px;
            }
          }
        }
      }

      .digital {
        div {
          height: 32px;

          &:before {
            width: 24px;
            height: 18px;
          }

          span {
            width: 160px;
          }

          i {
            width: 14px;
            height: 14px;
          }
        }
      }
    }

    .map {
      .item {
        span {
          &:before {
            width: 14px;
            height: 14px;
            margin-bottom: 5px;
          }
        }
      }
    }

    .features {
      .sub-title {
        font-size: 0.4rem;
      }

      .wrapper {
        display: block;
      }

      .tri {
        width: 284px;
        height: 215px;

        .nodes {
          height: 60px;

          &:first-child {
            height: 100px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/build/What.vue